/**
 *  Descrição: Cria uma lista de imagens estilizadas calculando 50% da distância da esquerda da anterior
 *  Data criação: 20/11/2018
 */
function init() {
     $(".helpers-img-list-absolute").each(function(){
          var $ul = $(this);
          $ul.css('height', $ul.find('li .helpers-img-cover').height());
          var $leftImg = 0;
          //Percorre todos os itens dessa tabela.
          $(this).find('li').each(function(event,element){
               var $widthEl = $(this).find('.helpers-img-cover').width();
               if(event != 0){
                    
                    $(this).css({left: $leftImg});
                    $leftImg = $leftImg + $widthEl/2;

               }else{
                    $(this).css({left: $leftImg});
                    $leftImg = $widthEl/2;
               }
          });
     }); 
 } 
 module.exports = {
     init
 }


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/imagesList.js